import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import BlogGridSlider from './BlogGridSlider'
import PartnerSlider from './PartnerSlider'

function Counter({ max, iconName, label }) {
    const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prevCount => {
        const increment = Math.ceil(max / 100); // Adjust speed here
        if (prevCount + increment >= max) {
          clearInterval(interval);
          return max;
        }
        return prevCount + increment;
      });
    }, 50); // Adjust interval here

    return () => clearInterval(interval);
  }, [max]);
  return (
    <div className="col-md-3 col-sm-3 co-xs-12">
      <div className="counter-container">
        <i className={`fa ${iconName}`} aria-hidden="true"></i>
        <div className="counter">{count}</div>
        <span>{label}</span>
      </div>
    </div>
  );
}
function About() {
  return (
    <div>
    <div className="breadcrumb-row">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                            <div className="breadcrumb-title-heading">
                                <h1 className="title">About Us</h1>
                            </div>
                            <div className="breadcrumb-wrapper">
                                <span className="mr-1"><i className="ti ti-home"></i></span>
                                <Link title="Homepage" to="/">Home</Link>
                                <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                                <span className="ttm-textcolor-skincolor">About Us</span>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>                    
    </div>
    {/* <!-- Section Start --> */}
    <section className="section-padding">
        <div className="container-fluid">
            <div className="row align-items-center">
                <div className="col-md-6">
                    <div className="image mb-xl-30 text-center">
                        <img src="/tm/react/toolways/assets/images/about.jpg" className="img-fluid" alt="img"/>
                    </div>
                </div>
                <div className="col-md-6 mb-xl-30">
                    <div className="section-header">
                        <h3 className="title mb-4">Cordless Drill Professional Combo Drill And Screwdriver </h3>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. , </p>
                    </div>
                    <ul className="about_list row">
                        <li className="col-lg-6 col-sm-6">
                           <i className="fa fa-phone" aria-hidden="true"></i>

                           <p className="mb-0">+123 - 456 - 7890</p>
                        </li>
                        <li className="col-lg-6 col-sm-6">
                           <i className="fa fa-envelope" aria-hidden="true"></i>

                           <p className="mb-0">example@gmail.com</p>
                        </li>
                    </ul>
                    <Link to="/about" className="thm-btn btn-rounded thm-bg-color-one">Read More</Link>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Section End -->
    <!-- Testimonial Start --> */}
    <BlogGridSlider/>
    {/* <!-- Testimonial End -->
     <!-- Discount Banner Start --> */}
    <section className="section-padding">
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-6">
                    <div className="discount_box shine-effect" style={{ backgroundImage: 'url(/tm/react/toolways/assets/images/discount_banner/34.png)' }}>
                        <div className="discount_text">
                            <h6 className="mb-0 subtitle">Discount 50%</h6>
                            <h4 className="title mb-2 text-light">Handy Tools</h4>
                            <p className="mb-3 text-light">Lorem ipsum dolor sit amet, consectetur.</p>
                            <Link to="/shop" className="thm-btn btn-rounded thm-bg-color-one">Shop Now</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="discount_box shine-effect" style={{ backgroundImage: 'url(/tm/react/toolways/assets/images/discount_banner/35.jpg)' }}>
                        <div className="discount_text">
                            <h6 className="mb-0 subtitle">Discount 30%</h6>
                            <h4 className="title mb-2 text-light">Cutter Power Tools</h4>
                            <p className="mb-3 text-light">Lorem ipsum dolor sit amet, consectetur.</p>
                            <Link to="/shop" className="thm-btn btn-rounded thm-bg-color-one">Shop Now</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Discount Banner End -->
     <!-- Counter --> */}
    <section className="section counter-sec section-bg relative newsletter_bg">
        <div className="container">
        <div className="row">
      <Counter max={300} iconName="fa-trophy" label="Award Shows" />
      <Counter max={99} iconName="fa-user" label="Happy Customer" />
      <Counter max={5000} iconName="fa-truck" label="Delivery Boys" />
      <Counter max={9000} iconName="fa-cart-plus" label="Store Locations" />
    </div>
            </div>
    </section>
    {/* <!-- Counter End-->
   <!--Partner Start--> */}
    <PartnerSlider/>
    </div>
  )
}

export default About